var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAffordable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard Copy 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-3",
    transform: "translate(18.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.60140351,13.2603509 C7.49645233,13.2472855 7.41304004,13.1659359 7.39735136,13.0613447 C7.38166268,12.9567535 7.43753616,12.854511 7.53403509,12.8112281 L42.5319298,1.17894737 C43.4594378,0.945722169 44.4426762,1.14896624 45.2017016,1.73081283 C45.960727,2.31265941 46.4123809,3.20936151 46.4280702,4.16561404 L46.4280702,14.4842105 L7.60140351,13.2603509 Z",
    id: "Path",
    stroke: "#231F20",
    fill: "#F2685B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3740351,14.8996491 L47.8989474,6.34385965 C48.82954,6.14786579 49.7986598,6.38840296 50.529603,6.99679281 C51.2605462,7.60518266 51.6729714,8.51455425 51.6491228,9.46526316 L51.6491228,19.6491228 L11.3740351,14.8996491 Z",
    id: "Path",
    stroke: "#231F20",
    fill: "#F2685B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2021053,56.4435088 L9.40912281,56.4435088 C4.27357264,56.3941274 0.143462644,52.2037971 0.168308528,47.0680702 L0.168308528,22.0294737 C0.143462644,16.8937468 4.27357264,12.7034164 9.40912281,12.6540351 L48.2021053,12.6540351 C53.3332573,12.7095495 57.4565794,16.8980823 57.431692,22.0294737 L57.431692,47.0680702 C57.4565794,52.1994616 53.3332573,56.3879944 48.2021053,56.4435088 L48.2021053,56.4435088 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2021053,56.4435088 L9.40912281,56.4435088 C4.27357264,56.3941274 0.143462644,52.2037971 0.168308528,47.0680702 L0.168308528,22.0294737 C0.143462644,16.8937468 4.27357264,12.7034164 9.40912281,12.6540351 L48.2021053,12.6540351 C53.3332573,12.7095495 57.4565794,16.8980823 57.431692,22.0294737 L57.431692,47.0680702 C57.4565794,52.1994616 53.3332573,56.3879944 48.2021053,56.4435088 L48.2021053,56.4435088 Z",
    id: "Path",
    stroke: "#231F20",
    fill: "#FFF2E3",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8203509,56.0168421 L9.79087719,56.0168421 C4.75713979,55.9613547 0.711011237,51.8550607 0.729759219,46.8210526 L0.729759219,22.2764912 C0.711059121,17.2443506 4.75894364,13.1412904 9.79087719,13.0919298 L47.8203509,13.0919298 C52.8478871,13.1474168 56.888989,17.248684 56.8702908,22.2764912 L56.8702908,46.8210526 C56.8951797,51.8532306 52.8522849,55.9613335 47.8203509,56.0168421 Z",
    id: "Path",
    fill: "#F2685B",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5915789,15.1017544 C55.6551895,16.9340481 56.8362168,19.5617316 56.8364912,22.3214035 L56.8364912,46.4729825 C56.9251909,51.5480143 52.9269651,55.756147 47.8540351,55.9270175 L9.30807018,55.9270175 C6.62059323,55.9107792 4.08696682,54.6708315 2.42526316,52.5585965",
    id: "Path",
    fill: "#FFF2E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1052632,41.1059649 L52.8729825,41.1059649 C49.8910263,41.0812754 47.4884606,38.6536307 47.4947246,35.6715789 L47.4947246,34.9866667 C47.4884962,32.0064674 49.8928343,29.5820512 52.8729825,29.5635088 L58.1052632,29.5635088 C61.0854113,29.5820512 63.4897495,32.0064674 63.483521,34.9866667 L63.483521,35.6715789 C63.489785,38.6536307 61.0872193,41.0812754 58.1052632,41.1059649 L58.1052632,41.1059649 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1052632,41.1059649 L52.8729825,41.1059649 C49.8910263,41.0812754 47.4884606,38.6536307 47.4947246,35.6715789 L47.4947246,34.9866667 C47.4884962,32.0064674 49.8928343,29.5820512 52.8729825,29.5635088 L58.1052632,29.5635088 C61.0854113,29.5820512 63.4897495,32.0064674 63.483521,34.9866667 L63.483521,35.6715789 C63.489785,38.6536307 61.0872193,41.0812754 58.1052632,41.1059649 L58.1052632,41.1059649 Z",
    id: "Path",
    stroke: "#000001",
    fill: "#F1695C",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 50,
    cy: 50,
    r: 50
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffordable);
export default __webpack_public_path__ + "static/media/affordable.9b73e48d3747fd699d351c166e7da98f.svg";
export { ForwardRef as ReactComponent };